import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Slider from 'react-slick';
import styled from 'styled-components';
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi2';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const SliderContainer = styled.div`
  width: 100%;
  height: auto;
  position: relative; /* Necesario para posicionar las flechas */
  padding-top: 0;
`;

const SlideWrapper = styled.div`
  height: auto;
  width: 100vw;
  display: flex !important;
  justify-content: center;
  align-items: flex-start;
  position: relative;
  overflow: hidden;
  padding: 0;
`;

const SlideImage = styled.img`
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
  max-height: 78vh;
  object-fit: contain;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.5);
  margin: 0 auto 6px;
  display: block;
`;

const StyledSlider = styled(Slider)`
  height: auto;
  width: 100%;
  position: relative;

  .slick-prev, .slick-next {
    top: 50%;
    transform: translateY(-50%);
  }

  .slick-prev {
    left: 12px;
  }

  .slick-next {
    right: 12px;
  }

  .slick-prev:before, .slick-next:before {
    content: none !important;
  }

  .slick-dots {
    position: relative;
    margin: -6px 0 0;
    padding: 0;
  }
`;

const ArrowButton = styled.button`
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.9);
  background: rgba(0, 0, 0, 0.65);
  box-shadow: 0 8px 22px rgba(0,0,0,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.85);
  }
`;

const LiveOverlay = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 20;
  width: 300px;
background: rgba(255, 255, 255, 0.75);

  border-radius: 16px;
  padding: 14px 16px;
  box-shadow: 0 10px 30px rgba(0,0,0,.35);
  color: white;
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media (max-width: 768px) {
    display: none;
  }
`;
const LiveMobileCTA = styled.a`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 30;

  background: rgba(255, 255, 255, 0.95);
  color: #40A4AE;
  padding: 10px 16px;
  border-radius: 999px;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  box-shadow: 0 6px 20px rgba(0,0,0,.35);

  display: none;
  align-items: center;
  gap: 10px;

  img {
    height: 26px;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    display: flex;
  }
`;


const LiveTop = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
`;


const LiveTitle = styled.div`
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 6px;
  color: #40A4AE;
font-weight: 700;


`;

const LiveLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;

  img {
    object-fit: contain;
  }

  .inpro {
    height: 40px;
  }

  .lu {
    height: 61px; /* más grande a propósito */
  }
`;



const LiveText = styled.div`
  align-self: center;

  font-size: 13px;
  line-height: 1.3;
`;

const LiveButton = styled.a`
  align-self: center;
background: #40A4AE;
color: white;

  padding: 7px 14px;
  border-radius: 8px;
  font-weight: 700;
  font-size: 13px;
  text-decoration: none;
  box-shadow: 0 4px 14px rgba(0,0,0,.25);

&:hover {
  background: #B91C1C;
}
`;

const isLiveVisible = () => {
  const now = new Date();

  // Próximo lunes a las 00:00
  const monday = new Date(now);
  const day = now.getDay(); // 0=domingo, 6=sábado
  const daysUntilMonday = (8 - day) % 7 || 7;

  monday.setDate(now.getDate() + daysUntilMonday);
  monday.setHours(0, 0, 0, 0);

  return now < monday;
};


const ImageSlider = () => {
  const [slides, setSlides] = useState([]);
  const isMobile = window.innerWidth <= 768;

  useEffect(() => {
    const fetchSlides = async () => {
      try {
        const url = isMobile
          ? 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders?mobile=true'
          : 'https://us-central1-inprojuy-f1173.cloudfunctions.net/app/ultimos-sliders';

        const response = await axios.get(url);
        setSlides(response.data);
      } catch (error) {
        console.error('Error fetching slides:', error);
      }
    };

    fetchSlides();
  }, [isMobile]);

  const PrevArrow = ({ className, onClick }) => (
    <ArrowButton className={className} onClick={onClick} aria-label="Anterior">
      <HiChevronLeft size={44} color="#fff" />
    </ArrowButton>
  );

  const NextArrow = ({ className, onClick }) => (
    <ArrowButton className={className} onClick={onClick} aria-label="Siguiente">
      <HiChevronRight size={44} color="#fff" />
    </ArrowButton>
  );

  const settings = {
    dots: true,
    infinite: true,
    speed: 1200,
    autoplay: true,
    autoplaySpeed: 7000,
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    cssEase: 'ease-in-out',
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    appendDots: dots => <div style={{ display: 'flex', justifyContent: 'center' }}>{dots}</div>
  };

  return (
    <SliderContainer>

      {/* CTA TRANSMISIÓN EN VIVO (oculto por pedido) */}
      {/*
        {isLiveVisible() && (
          <LiveOverlay>
            <LiveTop>
              <LiveLogos>
                <img className="inpro" src="/img/inprojuylogo1.png" alt="INPROJUY" />
                <img className="lu" src="https://loteria.chaco.gov.ar/uploads/resources/5c5978341c6d8683780791.png" alt="Lotería Unificada" />
              </LiveLogos>

              <LiveTitle>
                🔴 TRANSMISIÓN OFICIAL
              </LiveTitle>
            </LiveTop>

            <LiveButton
              href="#/sorteo-en-vivo"
              target="_blank"
              rel="noopener noreferrer"
            >
              VER SORTEO EN VIVO
            </LiveButton>
          </LiveOverlay>
        )}
        {isLiveVisible() && (
          <LiveMobileCTA
            href="#/sorteo-en-vivo"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src="https://loteria.chaco.gov.ar/uploads/resources/5c5978341c6d8683780791.png"
              alt="Lotería Unificada"
            />
            🔴 SORTEO EN VIVO
          </LiveMobileCTA>
        )}
      */}



      <StyledSlider {...settings}>
        {slides.map(slide => (
          <div key={slide.id}>
            <SlideWrapper bgImage={slide.imagen}>
              {slide.link ? (
                <a href={slide.link} target="_blank" rel="noopener noreferrer" style={{ display: 'block', width: '100%' }}>
                  <SlideImage src={slide.imagen} alt={slide.Slider} />
                </a>
              ) : (
                <SlideImage src={slide.imagen} alt={slide.Slider} />
              )}
            </SlideWrapper>
          </div>
        ))}
      </StyledSlider>

    </SliderContainer>
  );

}
export default ImageSlider;
